// What a maintenance probe learned. Available and Maintenance are both answers from the application;
// Unknown is the absence of one - a deploy blip, where the API is briefly unreachable - and must not
// be mistaken for either.
export enum MaintenanceProbeResult {
  Maintenance = 'maintenance',
  Available = 'available',
  Unknown = 'unknown'
}
